// extracted by mini-css-extract-plugin
export var container = "_hj-1";
export var cornerButtonContainer = "_hj-6";
export var disabled = "_hj-2";
export var dragActive = "_hj-3";
export var fileContainer = "_hj-5";
export var hiddenInput = "_hj-4";
export var widthContainer = "_hj-0";